var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMfFunnelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83009 1.65491L20.3763 1.65491C21.619 1.65491 22.3227 3.07929 21.5677 4.06628L13.6467 14.421C13.1819 15.0286 12.2113 14.6999 12.2113 13.935V13.1798C12.2113 12.7456 11.9311 12.361 11.5178 12.2279L9.68242 11.6369C8.73577 11.332 7.90154 10.7518 7.28637 9.97037L2.65148 4.08274C1.87687 3.09876 2.5778 1.65491 3.83009 1.65491Z",
    stroke: "#CFD0E7",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94922 5.6886L20.2687 5.6886M6.81461 9.20399L17.4804 9.20399",
    stroke: "#CFD0E7",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMfFunnelIcon);
export default __webpack_public_path__ + "static/media/mf_funnel_icon.f4eac5ab392dc7741b84481a22c815bd.svg";
export { ForwardRef as ReactComponent };